<template>
  <div class="info-card">
    <img :src="image" alt="Imagem Card" />
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'info-card',
  props: ['text', 'image'],
};
</script>

<style lang="scss" scoped>
.info-card {
  padding: 16px;
  border: 2px solid var(--color-secondary);
  border-radius: 4px;
  max-width: 230px;
  height: 350px;

  img {
    margin-bottom: 32px;
  }

  p {
    padding: 0 16px;
    text-align: center;
    font-size: 1.1em;
  }
}
</style>
